import * as React from 'react';

import { IBargainTerms } from '../../../types/results';
import { NewbuildingPrice } from '../../NewbuildingPrice';
import { PriceDiscount } from '../../PriceDiscount';
import { Text } from '../../Text';

export interface IBargainTermsInfoProps {
  bargainTerms: IBargainTerms;
  isNewbuilding: boolean;
  isBooked: boolean;
}

export function BargainTermsInfo({ bargainTerms, isNewbuilding, isBooked }: IBargainTermsInfoProps): JSX.Element {
  const { clientCommissionText, priceText, utilitiesText, depositText, discount } = bargainTerms;

  if (isNewbuilding && discount) {
    return <PriceDiscount newPrice={discount.newPrice} oldPrice={discount.oldPrice} percent={discount.percent} />;
  }

  if (isNewbuilding && priceText) {
    return <NewbuildingPrice priceText={priceText} isBooked={isBooked} />;
  }

  return (
    <>
      {priceText && (
        <div>
          <Text bold={true}>{priceText}</Text>
        </div>
      )}
      {depositText && (
        <div>
          <Text textSize="small" color="gray">
            {depositText}
          </Text>
        </div>
      )}
      {utilitiesText && (
        <div>
          <Text textSize="small" color="gray">
            {utilitiesText}
          </Text>
        </div>
      )}
      {clientCommissionText && (
        <div>
          <Text textSize="small" color="gray">
            {clientCommissionText}
          </Text>
        </div>
      )}
    </>
  );
}
